module.exports = __webpack_public_path__ + "static/index/img/baikal-307.2b563301.jpg";